"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixPanelGameSettingsActiveType = void 0;
var MixPanelGameSettingsActiveType;
(function (MixPanelGameSettingsActiveType) {
    MixPanelGameSettingsActiveType["LEADERBOARD"] = "leaderboard";
    MixPanelGameSettingsActiveType["USER_BASE"] = "userbase";
    MixPanelGameSettingsActiveType["CHALLENGE"] = "challenge";
    MixPanelGameSettingsActiveType["PRIZES"] = "prizes";
    MixPanelGameSettingsActiveType["SPLIT_GAME"] = "splitGame";
    MixPanelGameSettingsActiveType["TUTORIAL"] = "tutorial";
    MixPanelGameSettingsActiveType["VIEWS"] = "views";
    MixPanelGameSettingsActiveType["WELCOME_EMAIL"] = "welcomeEmail";
})(MixPanelGameSettingsActiveType || (exports.MixPanelGameSettingsActiveType = MixPanelGameSettingsActiveType = {}));
